export default "__VITE_ASSET__BM_ayaQz__"